<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined 
        >
        <v-row class="ma-1">
          <v-col cols="12" v-if="!published_by_admin" color="warning">
            <v-sheet
              outlined
              color="error"
              class="pa-4 white--text">
              La IDEA PROYECTO se encuentra BLOQUEADA por el administrador y no sera visible en la Galeria de Proyectos. Para mas información pongase
              en contacto con los organizadores de la JIJE.
            </v-sheet>  
          </v-col>

          <v-col cols="12">
            <h2 class="font-weight-light">Mi Stand:</h2>
          </v-col>

          <v-col cols="12">
            <v-text-field
              :maxlength="125"
              :counter="125"
              :rules="[v => (v || '' ).length <= 125 || 'El nombre de la idea no debe tener mas de 125 caracteres']"
              :disabled="!edition.edition.enable_edit_stand"
              ref="title"
              outlined
              v-model="title"
              label="Titulo"
              required
            ></v-text-field>

            <v-textarea
              :maxlength="250"
              :counter="250"
              :rules="[v => (v || '' ).length <= 249 || 'El slogan no debe tener mas de 250 caracteres']"
              :disabled="!edition.edition.enable_edit_stand"
              outlined
              ref="slogan"
              name="slogan"
              v-model="slogan"
              label="Slogan"
            ></v-textarea>

            <v-textarea
              :maxlength="1000"
              :counter="1000"
              :rules="[v => (v || '' ).length <= 999 || 'El resumen ejecutivo/descripción no debe tener mas de 1000 caracteres']"
              :disabled="!edition.edition.enable_edit_stand"
              outlined
              ref="description"
              name="description"
              v-model="description"
              label="Resumen ejecutivo/descripción"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        class="mt-4"
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4">
          <v-col cols="12">
            <h3 class="font-weight-regular">Canales de comunicación con el emprendimiento:</h3>
          </v-col>
          
          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="web"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="web"
              outlined
              label="Web"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="linkedin"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="linkedin"
              outlined
              label="Linkedin"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="instagram"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="instagram"
              outlined
              label="Instagram"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="facebook"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="facebook"
              outlined
              label="Facebook"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="twitter"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="twitter"
              outlined
              label="Twitter"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="youtube"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="youtube"
              outlined
              label="Youtube"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="whatsapp"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="whatsapp"
              outlined
              label="Whatsapp"
              placeholder="+5493426549877"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="telegram"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="telegram"
              outlined
              label="Telegram"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="discord"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="discord"
              outlined
              label="Discord"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="twitch"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="twitch"
              outlined
              label="Twitch"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="tiktok"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="tiktok"
              outlined
              label="Tiktok"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="snapchat"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="snapchat"
              outlined
              label="Snapchat"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="6" sm="12">
            <v-text-field
              ref="email"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="email"
              outlined
              label="Correo Electrónico"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        class="mt-4"
        width="100%"
        outlined
        min-height="180px"
        >
        <v-row class="ma-1">

          <v-col cols="12">
            <h2 class="font-weight-light">Datos de radicación:</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-select
              :items="[{ id: null, name: 'SELECCIONE UNA PAÍS' }, ...countries]"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="country_id"
              item-text="name"
              item-value="id"
              label="Pais*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="[{ id: null, name: 'SELECCIONE UNA PROVINCIA' }, ...provincias]"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="provincia_id"
              item-text="name"
              item-value="id"
              label="Provincia*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre del estado/provincia no debe tener mas de 200 caracteres']"
              :disabled="!edition.edition.enable_edit_stand||!country_id"
              ref="other_provincia"
              outlined
              v-model="other_provincia"
              label="Estado/provincia"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="[{ id: null, name: 'SELECCIONE UNA LOCALIDAD' }, ...localidades]"
              :disabled="!edition.edition.enable_edit_stand"
              v-model="localidad_id"
              item-text="name"
              item-value="id"
              label="Localidad*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la localidad no debe tener mas de 200 caracteres']"
              :disabled="!edition.edition.enable_edit_stand||!country_id"
              ref="other_localidad"
              outlined
              v-model="other_localidad"
              label="Localidad"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        class="mt-4"
        width="100%"
        outlined
        min-height="180px"
        >
        <v-row class="ma-1">
          <v-col cols="12">
            <h2 class="font-weight-light">Brochures (opcionales):</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" align="center">
            <v-file-input
              v-if="!brochure_1"
              outlined
              v-model="brochure_1"
              accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
              prepend-icon="mdi-file"
              label="Brochure 1 (opcional)"
              @change="updateBrochure(1, $event)"
              :disabled="!edition.edition.enable_edit_stand"
              :messages="['Archivos JPG, PNG o PDF, de hasta 5 MB']"
            ></v-file-input>

            <v-card
              max-width="240px"
              v-if="brochure_1"
              :disabled="!edition.edition.enable_edit_stand">
              <v-img
                contain
                :src="require('@/assets/icons/pdf-icon.png')"
                class="grey lighten-2"
                height="140px"
              >
              </v-img>

              <v-btn 
                class="mt-8 ml-8 pa-6"
                color="success"
                :href="url_brochure_1" >
                <v-icon
                  dark
                >
                  mdi-download
                </v-icon>
                  Descargar
              </v-btn>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteBrochure(1)">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" align="center">
            <v-file-input
              v-if="!brochure_2"
              outlined
              v-model="brochure_2"
              accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
              prepend-icon="mdi-file"
              label="Brochure 2 (opcional)"
              @change="updateBrochure(2, $event)"
              :disabled="!edition.edition.enable_edit_stand"
              :messages="['Archivos JPG, PNG o PDF, de hasta 5 MB']"
            ></v-file-input>

            <v-card
              max-width="240px"
              v-if="brochure_2"
              :disabled="!edition.edition.enable_edit_stand">
              <v-img
                contain
                :src="require('@/assets/icons/pdf-icon.png')"
                class="grey lighten-2"
                height="140px"
              >
              </v-img>

              <v-btn 
                class="mt-8 ml-8 pa-6"
                color="success"
                :href="url_brochure_2" >
                <v-icon
                  dark
                >
                  mdi-download
                </v-icon>
                  Descargar
              </v-btn>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteBrochure(2)">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" align="center">
            <v-file-input
              v-if="!brochure_3"
              outlined
              v-model="brochure_3"
              accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
              prepend-icon="mdi-file"
              label="Brochure 3 (opcional)"
              @change="updateBrochure(3, $event)"
              :disabled="!edition.edition.enable_edit_stand"
              :messages="['Archivos JPG, PNG o PDF, de hasta 5 MB']"
            ></v-file-input>

            <v-card
              max-width="240px"
              v-if="brochure_3"
              :disabled="!edition.edition.enable_edit_stand">
              <v-img
                contain
                :src="require('@/assets/icons/pdf-icon.png')"
                class="grey lighten-2"
                height="140px"
              >
              </v-img>

              <v-btn 
                class="mt-8 ml-8 pa-6"
                color="success"
                :href="url_brochure_3" >
                <v-icon
                  dark
                >
                  mdi-download
                </v-icon>
                  Descargar
              </v-btn>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteBrochure(3)">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 
          </v-col>

        </v-row>
      </v-sheet>

      <v-sheet
        class="mt-4"
        width="100%"
        outlined
        min-height="180px"
        >
        <v-row class="ma-1">
          <v-col cols="12">
            <h2 class="font-weight-light">Logo:</h2>
          </v-col>

          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!logo"
              v-model="logo"
              @change="onLogoChange"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Logo"
              :disabled="!edition.edition.enable_edit_stand"
              :messages="['Para una mejor visualización, usar un logo de 240px x 180px, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              max-width="380px"
              v-if="logo"
              :disabled="!edition.edition.enable_edit_stand">
              <v-img
                contain
                :src="url_logo"
                class="grey lighten-2"
                height="240px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteLogo()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>          
          </v-col>

          <v-col cols="12">
            <h2 class="font-weight-light">Imagenes <small><small>{{ (type_postulations_id==3)?'(máximo cinco)':'(máximo tres)' }}</small></small>:</h2>
          </v-col>

          <template v-if="type_postulations_id!=3">
            <v-col cols="12" xl="4" md="4" sm="12">
              <v-file-input
                outlined
                v-if="!image_1"
                v-model="image_1"
                @change="onImageChange(1)"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                label="Imagen 1"
                :disabled="!edition.edition.enable_edit_stand"
              ></v-file-input>

              <v-card
                max-width="380px"
                v-if="image_1"
                :disabled="!edition.edition.enable_edit_stand">
                <v-img
                  contain
                  :src="url_image_1"
                  class="grey lighten-2"
                  height="240px"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteImage(1)">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>            
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <v-file-input
                outlined
                v-if="!image_2"
                v-model="image_2"
                @change="onImageChange(2)"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                label="Imagen 2"
                :disabled="!edition.edition.enable_edit_stand"
              ></v-file-input>

              <v-card
                max-width="380px"
                v-if="image_2"
                :disabled="!edition.edition.enable_edit_stand">
                <v-img
                  contain
                  :src="url_image_2"
                  class="grey lighten-2"
                  height="240px"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteImage(2)">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>            
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <v-file-input
                outlined
                v-if="!image_3"
                v-model="image_3"
                @change="onImageChange(3)"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                label="Imagen 3"
                :disabled="!edition.edition.enable_edit_stand"
              ></v-file-input>

              <v-card
                max-width="380px"
                v-if="image_3"
                :disabled="!edition.edition.enable_edit_stand">
                <v-img
                  contain
                  :src="url_image_3"
                  class="grey lighten-2"
                  height="240px"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteImage(3)">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>            
            </v-col>
          </template>

          <template v-if="type_postulations_id==3">

            <v-col cols="12" xl="4" md="4" sm="12">
              <v-file-input
                outlined
                v-if="!image_1"
                v-model="image_1"
                @change="onImageChange(1)"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                label="Imagen 1"
                :disabled="!edition.edition.enable_edit_stand"
              ></v-file-input>

              <v-card
                max-width="380px"
                v-if="image_1"
                :disabled="!edition.edition.enable_edit_stand">
                <v-img
                  contain
                  :src="url_image_1"
                  class="grey lighten-2"
                  height="240px"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteImage(1)">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>            
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <v-file-input
                outlined
                v-if="!image_2"
                v-model="image_2"
                @change="onImageChange(2)"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                label="Imagen 2"
                :disabled="!edition.edition.enable_edit_stand"
              ></v-file-input>

              <v-card
                max-width="380px"
                v-if="image_2"
                :disabled="!edition.edition.enable_edit_stand">
                <v-img
                  contain
                  :src="url_image_2"
                  class="grey lighten-2"
                  height="240px"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteImage(2)">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>            
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <v-file-input
                outlined
                v-if="!image_3"
                v-model="image_3"
                @change="onImageChange(3)"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                label="Imagen 3"
                :disabled="!edition.edition.enable_edit_stand"
              ></v-file-input>

              <v-card
                max-width="380px"
                v-if="image_3"
                :disabled="!edition.edition.enable_edit_stand">
                <v-img
                  contain
                  :src="url_image_3"
                  class="grey lighten-2"
                  height="240px"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteImage(3)">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>            
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <v-file-input
                outlined
                v-if="!image_4"
                v-model="image_4"
                @change="onImageChange(4)"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                label="Imagen 4"
                :disabled="!edition.edition.enable_edit_stand"
              ></v-file-input>

              <v-card
                max-width="380px"
                v-if="image_4"
                :disabled="!edition.edition.enable_edit_stand">
                <v-img
                  contain
                  :src="url_image_4"
                  class="grey lighten-2"
                  height="240px"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteImage(4)">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>            
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <v-file-input
                outlined
                v-if="!image_5"
                v-model="image_5"
                @change="onImageChange(5)"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                label="Imagen 5"
                :disabled="!edition.edition.enable_edit_stand"
              ></v-file-input>

              <v-card
                max-width="380px"
                v-if="image_5"
                :disabled="!edition.edition.enable_edit_stand">
                <v-img
                  contain
                  :src="url_image_5"
                  class="grey lighten-2"
                  height="240px"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteImage(5)">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>            
            </v-col>

          </template>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12">
            <h2 class="font-weight-light">Video:</h2>
          </v-col>

          <v-col cols="12">

            <v-text-field
              outlined
              v-model="video"
              label="Video"
              :disabled="!edition.edition.enable_edit_stand"
              :messages="['Links a videos de Youtube']"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-switch
              v-model="published"
              :disabled="!edition.edition.enable_edit_stand"
              label="Publicar la vidriera para que sea visible por los demas emprendimientos."
            ></v-switch>
          </v-col>  
        </v-row>
      </v-sheet>

    </v-col>

    <v-col cols="12" class="pt-8 d-sm-flex">
      <v-btn
        :block="$vuetify.breakpoint.xsOnly"
        depressed
        color="#0097B4"
        class="white--text mr-auto mt-2"
        :disabled="loading_update||loading_preview"
        :to="{ name: 'myEntrepreneurship'}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-spacer />

      <v-btn
        :block="$vuetify.breakpoint.xsOnly"
        depressed
        color="#0097B4"
        class="mr-2 mt-2 white--text"
        @click="updateMyWindow"
        :loading="loading_update"
        :disabled="loading_preview||!edition.edition.enable_edit_stand">
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>

      <v-btn
        :block="$vuetify.breakpoint.xsOnly"
        depressed
        color="#0097B4"
        class="mr-2 mt-2 white--text"
        @click="previewMyWindow"
        :disabled="loading_update||!edition.edition.enable_edit_stand"
        :loading="loading_preview">
        <v-icon left>
          mdi-eye
        </v-icon>
        Previsualizar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="dialog_error"
      max-width="490">
      <v-card>
        <v-card-title class="text-h5">
          Avertencia
        </v-card-title>

        <v-card-text>
          No pueden quedar campos vacios ni imagenes sin cargar cuando 
          pública su stand virtual. Por favor, complete todos los campos:

          <ul 
            class="mt-2" 
            v-for="error in errors" :key="error">
            <li>{{ error }}</li>
          </ul>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary darken-1"
            text
            @click="closeDielogError()"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_upload"
      persistent
      max-width="490"
    >
      <v-card>
        <v-card-title class="text-h5 font-weight-light">
          Cargando Imagenes
        </v-card-title>
        <v-card-text>
          <v-progress-linear
            v-model="uploadPercentage"
            color="primary"
            height="25"
          >
            <strong>{{ uploadPercentage}}%</strong>
          </v-progress-linear>
          <h4 class="font-weight-light" v-if="uploadPercentage!=100">Subiendo archivos al servidor...</h4>
          <h4 class="font-weight-light" v-if="uploadPercentage==100">Esperando respuesta del servidor...</h4>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  const APP_URL = process.env.VUE_APP_URL
  import download from 'downloadjs'

  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    name: 'myWindow',

    data: () => ({
      show: false,
      dialog_error: false,

      loading:true,
      loading_update:false,
      loading_preview:false,
      dialog_upload:false,

      loading_brochure:false,
      
      uploadPercentage:null,
      color:'grey',

      window:[], 

      type_postulations_id:null,
      
      id: null,
      title:'',
      description:'',
      slogan:'',

      argentina_id: null, 
      country_id: null,
      provincia_id: null,
      localidad_id: null,
      countries:[],
      provincias:[],
      localidades:[],

      other_provincia:null,
      other_localidad:null,

      web: null,
      linkedin: null,
      instagram: null,
      facebook: null,
      twitter: null,
      youtube: null,
      whatsapp: null,
      telegram: null,
      discord: null,
      twitch: null,
      tiktok: null,
      snapchat: null,
      email: null,

      brochure_1:null,
      url_brochure_1:null,
      
      brochure_2:null,
      url_brochure_2:null,
      
      brochure_3:null,
      url_brochure_3:null,

      logo:null,
      url_logo:null,

      image_1: null,
      url_image_1: null,

      image_2: null,
      url_image_2: null,

      image_3: null,
      url_image_3: null,
      
      image_4: null,
      url_image_4: null,

      image_5: null,
      url_image_5: null,

      image_6: null,
      url_image_6: null,

      video: null,

      degree_development: 'MDN reformulado',
      items: ['MDN reformulado', 'Validado', 'Redactado y aprobado', 'En construcción'],

      user_id:null,
      edition_id:null,
      convocation_form_id:null,
      published:false,
      published_by_admin:true,

      errors:[],
    }),
    computed: {
      ...mapGetters([ 
          'convocation_form', 'edition'
      ])
    },
    methods:{
      onLogoChange() {
        this.url_logo = URL.createObjectURL(this.logo);
      }, 

      updateBrochure(id, file) {
        if (!file) return
        const validType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)
        const validExtension = /\.(jpe?g|png|pdf)$/i.test(file.name)
        if (!validType || !validExtension || file.size > 5 * 1024 * 1024) {
          this.deleteBrochure(id)
          this.errors = [`El brochure ${id} debe ser un archivo JPG, PNG o PDF de hasta 5 MB.`]
          this.dialog_error = true
          return
        }
        this[`url_brochure_${id}`] = URL.createObjectURL(file)
      },

      deleteBrochure(id){
        switch (id) {
          case 1:
            this.brochure_1=null
            this.url_brochure_1=null
            break;
          case 2:
            this.brochure_2=null
            this.url_brochure_2=null
            break;
          case 3:
            this.brochure_3=null
            this.url_brochure_3=null
            break;
          default:
            break;
        }
      },

      async donwloadBrochure(url){
        this.loading_brochure=true
        url = APP_URL+this.brochure
        await axios.get(
          url, 
          {responseType: 'blob'}
        ).then((response) => {
          console.log(response)
          const content = response.headers['content-type'];
          download(response.data, 'Brochure.pdf', content)
          this.loading_brochure=false
        })
      },

      deleteLogo(){
        this.logo=null
        this.url_logo=null
      },

      onImageChange(image) {
        switch (image) {
          case 1:
            this.url_image_1 = URL.createObjectURL(this.image_1);
            break
          case 2:
            this.url_image_2 = URL.createObjectURL(this.image_2);
            break
          case 3:
            this.url_image_3 = URL.createObjectURL(this.image_3);
            break
          case 4:
            this.url_image_4 = URL.createObjectURL(this.image_4);
            break
          case 5:
            this.url_image_5 = URL.createObjectURL(this.image_5);
            break
          case 6:
            this.url_image_6 = URL.createObjectURL(this.image_6);
            break
        }
      }, 

      deleteImage(image) {
        switch (image) {
          case 1:
            this.image_1=null
            this.url_image_1=null
            break
          case 2:
            this.image_2=null
            this.url_image_2=null
            break
          case 3:
            this.image_3=null
            this.url_image_3=null
            break
          case 4:
            this.image_4=null
            this.url_image_4=null
            break
            case 5:
            this.image_5=null
            this.url_image_5=null
            break
        }
      },

      async getMyWindow(){
        await axios.get('entrepreneurship-window/'+ this.convocation_form.convocation_form.id ).then(response =>{

          this.window = response.data.data.window
          this.id = response.data.data.window.id
          this.title = response.data.data.window.title
          this.description = response.data.data.window.description
          this.slogan = response.data.data.window.slogan
          
          this.country_id = response.data.data.window.country_id
          this.provincia_id = response.data.data.window.provincia_id
          this.localidad_id = response.data.data.window.localidad_id

          this.other_provincia = response.data.data.window.other_provincia
          this.other_localidad = response.data.data.window.other_localidad

          this.web = response.data.data.window.web
          this.linkedin = response.data.data.window.linkedin
          this.instagram = response.data.data.window.instagram
          this.facebook = response.data.data.window.facebook
          this.twitter = response.data.data.window.twitter
          this.youtube = response.data.data.window.youtube
          this.whatsapp = response.data.data.window.whatsapp
          this.telegram = response.data.data.window.telegram
          this.discord = response.data.data.window.discord
          this.twitch = response.data.data.window.twitch
          this.tiktok = response.data.data.window.tiktok
          this.snapchat = response.data.data.window.snapchat
          this.email = response.data.data.window.email

          this.brochure_1 = response.data.data.window.brochure_1
          this.url_brochure_1 = APP_URL + this.brochure_1

          this.brochure_2 = response.data.data.window.brochure_2
          this.url_brochure_2 = APP_URL + this.brochure_2

          this.brochure_3 = response.data.data.window.brochure_3
          this.url_brochure_3 = APP_URL + this.brochure_3

          this.logo = response.data.data.window.logo
          this.url_logo = APP_URL + this.logo

          this.image_1 = response.data.data.window.image_1
          this.url_image_1 = APP_URL + this.image_1
          
          this.image_2 = response.data.data.window.image_2
          this.url_image_2 = APP_URL + this.image_2

          this.image_3 = response.data.data.window.image_3
          this.url_image_3 = APP_URL + this.image_3

          this.image_4 = response.data.data.window.image_4
          this.url_image_4 = APP_URL + this.image_4

          this.image_5 = response.data.data.window.image_5
          this.url_image_5 = APP_URL + this.image_5

          this.video = response.data.data.window.video

          this.edition_id = response.data.data.window.edition_id
          this.convocation_form_id = response.data.data.window.convocation_form_id
          this.entrepreneurship_id = response.data.data.window.entrepreneurship_id
          this.type_postulations_id =  response.data.data.window.type_postulations_id

          this.published = response.data.data.window.published
          this.published_by_admin = response.data.data.window.published_by_admin
          this.loading = false
        }).catch(error => {
          console.log(error);
        })
      },

      async updateMyWindow(){
        this.loading_update=true

        let formData= new FormData()

        formData.append('id', this.id)
        formData.append('title', this.title)

        if(this.description!=null){
          formData.append('description', this.description);
        }

        if(this.slogan!=null){
          formData.append('slogan', this.slogan);
        }

        if(this.web!=null){
          formData.append('web', this.web);
        }

        if(this.linkedin!=null){
          formData.append('linkedin', this.linkedin);
        }

        if(this.instagram!=null){
          formData.append('instagram', this.instagram);
        }

        if(this.facebook!=null){
          formData.append('facebook', this.facebook);
        }

        if(this.twitter!=null){
          formData.append('twitter', this.twitter);
        }
        
        if(this.youtube!=null){
          formData.append('youtube', this.youtube);
        }
        
        if(this.whatsapp!=null){
          formData.append('whatsapp', this.whatsapp);
        }

        if(this.telegram!=null){
          formData.append('telegram', this.telegram);
        }

        if(this.discord!=null){
          formData.append('discord', this.discord);
        }

        if(this.twitch!=null){
          formData.append('twitch', this.twitch);
        }

        if(this.tiktok!=null){
          formData.append('tiktok', this.tiktok);
        }

        if(this.snapchat!=null){
          formData.append('snapchat', this.snapchat);
        }

        if(this.email!=null){
          formData.append('email', this.email);
        }

        if(this.country_id!=null){
          formData.append('country_id', this.country_id);
        }

        if(this.provincia_id!=null){
          formData.append('provincia_id', this.provincia_id);
        }

        if(this.other_provincia!=null){
          formData.append('other_provincia', this.other_provincia);
        }

        if(this.localidad_id!=null){
          formData.append('localidad_id', this.localidad_id);
        }

        if(this.other_localidad!=null){
          formData.append('other_localidad', this.other_localidad);
        }

        if(this.brochure_1!=null){
          formData.append('brochure_1', this.brochure_1);
        }

        if(this.brochure_2!=null){
          formData.append('brochure_2', this.brochure_2);
        }

        if(this.brochure_3!=null){
          formData.append('brochure_3', this.brochure_3);
        }

        if(this.logo!=null){
          formData.append('logo', this.logo);
        }
        
        if(this.image_1!=null){
          formData.append('image_1', this.image_1);
        }

        if(this.image_2!=null){
          formData.append('image_2', this.image_2);
        }

        if(this.image_3!=null){
          formData.append('image_3', this.image_3);
        }

        if(this.image_4!=null){
          formData.append('image_4', this.image_4);
        }

        if(this.image_5!=null){
          formData.append('image_5', this.image_5);
        }

        if(this.video!=null){
          formData.append('video', this.video);
        }

        formData.append('published', this.published)

        try {
          await axios({
            method: 'post',
            url: 'entrepreneurship-window/'+ this.convocation_form.convocation_form.id,
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( response =>{
            console.log('Response: '+response.data)
            this.loading_update=false
            this.$router.push({ name: 'myEntrepreneurship' })
          })
        } catch (error) {
          this.loading_update=false
          this.dialog_error = true
          this.errors = []
          let errors = error.response.data.errors
          for (const imageKey in errors) {
            errors[imageKey].forEach((error, index) => {
              console.log(`Error ${index + 1}: ${error}`);
              this.errors.push(error)
            });
          }

          this.loading=false
        }
      },

      async previewMyWindow(){
        this.loading_preview=true

        let formData= new FormData()

        formData.append('id', this.id)
        formData.append('title', this.title)

        if(this.description!=null){
          formData.append('description', this.description);
        }

        if(this.slogan!=null){
          formData.append('slogan', this.slogan);
        }

        if(this.web!=null){
          formData.append('web', this.web);
        }

        if(this.linkedin!=null){
          formData.append('linkedin', this.linkedin);
        }

        if(this.instagram!=null){
          formData.append('instagram', this.instagram);
        }

        if(this.facebook!=null){
          formData.append('facebook', this.facebook);
        }

        if(this.twitter!=null){
          formData.append('twitter', this.twitter);
        }
        
        if(this.youtube!=null){
          formData.append('youtube', this.youtube);
        }
        
        if(this.whatsapp!=null){
          formData.append('whatsapp', this.whatsapp);
        }

        if(this.telegram!=null){
          formData.append('telegram', this.telegram);
        }

        if(this.discord!=null){
          formData.append('discord', this.discord);
        }

        if(this.twitch!=null){
          formData.append('twitch', this.twitch);
        }

        if(this.tiktok!=null){
          formData.append('tiktok', this.tiktok);
        }

        if(this.snapchat!=null){
          formData.append('snapchat', this.snapchat);
        }

        if(this.email!=null){
          formData.append('email', this.email);
        }

        formData.append('country_id', this.country_id ?? '');
        formData.append('provincia_id', this.provincia_id ?? '');
        formData.append('localidad_id', this.localidad_id ?? '');
        formData.append('other_provincia', this.other_provincia ?? '');
        formData.append('other_localidad', this.other_localidad ?? '');
        
        if(this.brochure_1!=null){
          formData.append('brochure_1', this.brochure_1);
        }

        if(this.brochure_2!=null){
          formData.append('brochure_2', this.brochure_2);
        }

        if(this.brochure_3!=null){
          formData.append('brochure_3', this.brochure_3);
        }

        if(this.logo!=null){
          formData.append('logo', this.logo);
        }
        
        if(this.image_1!=null){
          formData.append('image_1', this.image_1);
        }

        if(this.image_2!=null){
          formData.append('image_2', this.image_2);
        }

        if(this.image_3!=null){
          formData.append('image_3', this.image_3);
        }

        if(this.image_4!=null){
          formData.append('image_4', this.image_4);
        }

        if(this.image_5!=null){
          formData.append('image_5', this.image_5);
        }

        if(this.video!=null){
          formData.append('video', this.video);
        }

        formData.append('published', this.published)

        try {
          await axios({
            method: 'post',
            url: 'entrepreneurship-window/'+ this.convocation_form.convocation_form.id,
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( response =>{
            console.log('Response: '+response.data)
            this.loading_preview=false
            this.$router.push({ name: 'previewWindow' })
          })
        } catch (error) {
          
          this.errors = []
          this.loading_preview = false
          let errors = error.response.data.errors
          for (const imageKey in errors) {
            errors[imageKey].forEach((error, index) => {
              console.log(`Error ${index + 1}: ${error}`);
              this.errors.push(error)
            });
          }
          this.dialog_error = true
          this.loading_preview=false
        }
      },

      closeDielogError(){
        this.dialog_error = false
        this.loading_update = false
        this.loading_preview = false
      },

      async getCountries(){
        try {
          await axios.get('countries').then(response =>{
            this.countries = response.data.data.countries

            this.countries.forEach(element=>{
              if(element.name=='Argentina'){
                this.argentina_id=element.id
              }
            })
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getProvincias(){
        try {
          await axios.get('provincias').then(response =>{
            this.provincias = response.data.provincias
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getLocalidades(){
        try {
          await axios.get('provincias-localidades/'+this.provincia_id).then(response =>{
            this.localidades = response.data.provincia.localidads
          }).catch(error => {
            console.log(error);
          })
          
        } catch (error) {
          console.log(error)
        }
      },
    },
    watch: {
      provincia_id ( olvValue) {
        // Siempre que cambia el país, reseteo todo lo relacionado
        if(olvValue==null){
          this.localidad_id = null
          this.localidades = []
        }else{
          this.getLocalidades()
        }
      }
    },
    created(){
      Promise.all([
        this.getMyWindow()
      ]).then(() => {
        this.getCountries(),
        this.getProvincias()
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>